<template>
  <!--begin::Advance Table Widget 10-->
  <div>
    <div class="card card-custom gutter-b">
      <AddWhiteList v-bind:dialog.sync="whiteListDialog"></AddWhiteList>
      <!--begin::Alert-->
      <b-alert :show="true" variant="secondary" class="font-size-lg">
        <p>提示：</p>
        <p>1.每新增一个短效代理订单，可额外添加3个白名单IP</p>
        <p>2.您当前的 IP 地址是：{{ ipAddr }}</p>
        <p>
          3. IP
          不能是本地地址（如：127.0.0.1）、保留地址（如：0.0.0.0）及局域网地址（如：192.168.0.1）
        </p>
        <p>4. 支持 API 动态管理白名单 IP。请参考 API 文档</p>
      </b-alert>

      <!--end::Alert-->

      <!--begin::Header-->
      <div class="card-header border-0 py-5">
        <h3 class="card-title align-items-start flex-column">
          <span class="card-label text-dark">
            <span>可添加白名单名额为</span>
            <span class="font-size-h2">{{ maxNums }}</span>
            <span>个</span>
          </span>
        </h3>
        <div class="card-toolbar">
          <v-btn
            color="primary font-weight-bolder font-size-sm"
            dark
            @click="openWhiteList"
            >添加白名单</v-btn
          >
        </div>
      </div>
      <!--end::Header-->
      <!--begin::Body-->
      <div class="card-body py-0">
        <!--begin::Table-->
        <div class="table-responsive">
          <table
            class="table table-head-custom table-vertical-center"
            id="kt_advance_table_widget_4"
          >
            <thead>
              <tr class="text-left">
                <th class="pl-0" style="width: 30px">
                  <label class="checkbox checkbox-lg checkbox-single mr-2">
                    <input
                      type="checkbox"
                      @input="setCheck($event.target.checked)"
                    />
                    <span></span>
                  </label>
                </th>
                <th class="pl-0" style="min-width: 120px">添加时间</th>
                <th style="min-width: 110px">已添加的 IP</th>
                <th style="min-width: 110px">类型</th>
                <th style="min-width: 120px">备注</th>
                <th style="min-width: 120px" class="text-right">动作</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, i) in list">
                <tr v-bind:key="i">
                  <td class="pl-0 py-6">
                    <label class="checkbox checkbox-lg checkbox-single">
                      <input type="checkbox" :value="i" :checked="checked" />
                      <span></span>
                    </label>
                  </td>
                  <td class="pl-0">
                    <span
                      class="text-dark-75 font-weight-bolder d-block font-size-lg"
                      >{{ item.ctime | parseTime("{m}/{d}/{y}") }}</span
                    >
                  </td>
                  <td>
                    <span
                      class="text-dark-75 font-weight-bolder d-block font-size-lg"
                      >{{ item.ip_addr }}</span
                    >
                  </td>

                  <td>
                    <span
                      class="text-dark-75 font-weight-bolder d-block font-size-lg"
                      >{{ item.typeMemo }}</span
                    >
                  </td>

                  <td>
                    <span
                      class="text-dark-75 font-weight-bolder d-block font-size-lg"
                      >{{ item.memo }}</span
                    >
                  </td>

                  <td class="text-right">
                    <a
                      class="btn btn-sm btn-primary font-weight-bold mr-2 py-2 px-3 px-xxl-5 my-1"
                      @click="deleteWhiteList(item)"
                      >删除</a
                    >
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <!--end::Table-->
      </div>
      <!--end::Body-->
    </div>
    <!--end::Advance Table Widget 10-->
    <b-pagination
      v-model="currentPage"
      :total-rows="pagination.total"
      :per-page="limit"
      aria-controls="my-table"
      class="mt-3 text-right float-right"
    ></b-pagination>
  </div>
</template>

<script>
import { getInstance, deleteInstance } from "@/api/instance";
import { whiteListNums } from "@/api/whitelist";
import { getIp } from "@/api/message";
import AddWhiteList from "@/view/pages/whitelist/AddWhiteList";

export default {
  name: "WhiteList",
  data() {
    return {
      checked: false,
      whiteListDialog: false,
      list: [],
      nums: {},
      maxNums: 0,
      waitOpenVoicePrices: 0,
      ipAddr: "",
      pagination: {
        total: "",
      },
      currentPage: 1,
      limit: 10,
    };
  },
  components: { AddWhiteList },
  watch: {
    currentPage: {
      handler: function () {
        this.fetchWhiteList({
          status$in: "0,1",
          $limit: this.limit,
          $start: this.currentPage * this.limit - this.limit,
        });
      },
      deep: true,
    },
  },
  created() {
    this.fetchIp();
    this.fetchWhiteList({ status$in: "0,1", $limit: this.limit });
    this.fetchWhiteListNum();
  },
  methods: {
    setCheck(check) {
      if (check) {
        this.checked = check;
      } else {
        this.checked = false;
      }
    },
    fetchIp() {
      getIp().then((res) => {
        this.ipAddr = res.result.ip_addr;
      });
    },
    fetchWhiteList(params) {
      getInstance("WHITELIST", params).then((res) => {
        this.list = res.result;
        this.pagination.total = res.total;
        this.list.forEach((item) => {
          if (item.type === "base") {
            item.typeMemo = "基础白名单";
          } else {
            item.typeMemo = "额外白名单";
          }
        });
      });
    },
    fetchWhiteListNum() {
      whiteListNums().then((res) => {
        this.nums = res.result;
        this.maxNums = this.nums["base_num"] + this.nums["other_num"];
      });
    },
    openWhiteList() {
      this.whiteListDialog = true;
    },
    deleteWhiteList(data) {
      this.$bvModal
        .msgBoxConfirm("此操作将永久删除该记录，是否继续？", {
          title: "提示",
          okVariant: "warning",
          okTitle: "确认",
          cancelTitle: "取消",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((val) => {
          if (val) {
            deleteInstance("WHITELIST", { _id: data._id["$oid"] }).then(() => {
              this.fetchWhiteList({ status$in: "0,1", $limit: this.limit });
              this.fetchWhiteListNum();
            });
          }
        });
    },
  },
};
</script>
